import { DatePipe, TitleCasePipe } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import { CentralServiceResources as cs } from 'se-resource-types'

@Component({
  selector: 'se-po-persona-choice',
  templateUrl: './persona-choice.component.html',
  styleUrls: ['./persona-choice.component.scss'],
})
export class PersonaChoiceComponent implements OnInit {
  @Input() public profile: cs.Households.UserProfile
  @Output() public edit = new EventEmitter<cs.Households.UserProfile>()
  @Output() public chosen = new EventEmitter<cs.Households.UserProfile>()

  public imageUrl: string
  public ready = false
  public subtitle: string[]

  constructor(
    private seFeTranslationsLoader: SeFeTranslationsLoader,
    private datePipe: DatePipe,
    private titleCasePipe: TitleCasePipe
  ) {
    // n00p
  }

  public ngOnInit(): void {
    this.initTranslations()
    this.setFields()
  }

  public onEdit(e: MouseEvent): void {
    e.stopImmediatePropagation()
    this.edit.emit(this.profile)
  }

  public onChosen(): void {
    this.chosen.emit(this.profile)
  }

  public onKeydown(e: KeyboardEvent): void {
    if (e.code === 'Space' || e.code === 'Enter') {
      this.onChosen()
    }
  }

  private initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-persona-choice/assets/translations').then(() => {
      this.ready = true
    })
  }

  private setFields(): void {
    const dob = this.profile?.persona?.date_of_birth ? this.datePipe.transform(this.profile.persona.date_of_birth, 'MMM d, y') : ''
    const gender = this.profile?.persona?.gender ? this.titleCasePipe.transform(this.profile.persona.gender) : ''
    this.subtitle = [dob, gender].filter(f => !!f)
    this.setImageUrl()
  }

  private setImageUrl(): void {
    const profileImages = this.profile?.persona?.profile_images
    this.imageUrl = (profileImages || []).find(i => i.image_type === 'crop')?.url
  }
}
